import { Link, useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const QUICK = [
    [t.footer.links.home, "home"], [t.footer.links.about, "about"], [t.footer.links.industries, "industries"],
    [t.footer.links.services, "services"], [t.footer.links.rfq, "rfq"], [t.footer.links.suppliers, "suppliers"],
    [t.footer.links.contact, "contact"],
  ];

  const LEGAL = [
    [t.footer.legal.privacy, "/legal/privacy"],
    [t.footer.legal.terms, "/legal/terms"],
    [t.footer.legal.disclaimer, "/legal/disclaimer"],
  ];

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else {
      scrollToId(id);
    }
  };

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#04070F]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-8 bg-gold flex items-center justify-center font-display font-black text-midnight text-lg">N</span>
            <span className="leading-none">
              <span className="block font-display font-extrabold tracking-tight text-lg text-[#F4F6F8]">NOREX</span>
              <span className="block text-[9px] uppercase tracking-[0.3em] text-[#94A3B8]">International Trading Ltd.</span>
            </span>
          </div>
          <p className="text-sm text-[#94A3B8] leading-relaxed max-w-sm">
            {t.footer.blurb}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">{t.footer.quickTitle}</p>
          <ul className="space-y-3">
            {QUICK.map(([label, id]) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => go(id)}
                  className="text-sm text-[#94A3B8] hover:text-[#F4F6F8] transition-colors duration-200"
                >
                  {label}
                </button>
              </li>
            ))}
            <li>
              <Link
                data-testid="footer-link-insights"
                to="/insights"
                className="text-sm text-[#94A3B8] hover:text-[#F4F6F8] transition-colors duration-200"
              >
                {t.footer.links.insights}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">{t.footer.legalTitle}</p>
          <ul className="space-y-3">
            {LEGAL.map(([label, to]) => (
              <li key={to}>
                <Link
                  data-testid={`footer-${to.split("/").pop()}-link`}
                  to={to}
                  className="text-sm text-[#94A3B8] hover:text-[#F4F6F8] transition-colors duration-200"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">{t.footer.officeTitle}</p>
          <p className="text-sm text-[#94A3B8] leading-relaxed">
            Plots No. 3088, CCC Ark of Covenant, Lugbe, Abuja, Nigeria.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-3">
          <p className="text-xs text-[#94A3B8]" data-testid="footer-copyright">
            {t.footer.copyright}
          </p>
          <Link to="/admin" data-testid="footer-admin-link" className="text-xs text-[#94A3B8]/60 hover:text-gold transition-colors duration-200">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
